export default __webpack_public_path__ + "static/media/MercadoNacional_EN.087e9651.jpg";